export class MonitoringDashboardCommon {
    subHeading: string;
    firstHeading:string;
    redColor: number;
    secondHeading: string;
    yellowColor: number;
    thirdHeading: string;
    greenColor: number;
    fourthHeading: string;
    greyColor: number;
}
